import React, { useEffect, useState } from "react";
import { basicColumns } from "./column";
import { ActionIcon } from "rizzui/action-icon";
import Add from "../../assets/add";
import { Text } from "rizzui/typography";
import SortByProject from "../dashboard/sortProjects";
import { useModal } from "../../hooks/useModal";
import { useDrawer } from "../../hooks/useDrawer";
import ImportFile from "../../component/cards/importFile";
import FilterButton from "../../component/filter";
import { Popover } from "rizzui/popover";
import SingleEntry from "../../component/singleEntry";
import { Button } from "rizzui/button";
import DataTable from "../../component/table";
import RightDrawer from "../../layout/appLayout/rightDrawer";
import MyLoader from "../../component/loader";
import BlankPage from "./blank";
import UseFetchData from "../../hooks/useFetchData";
import { objectToUrlParams } from "../../lib/utils/objToURIParams";
import { StatusFilter } from "../../component/filters";

export const orderData = [
  {
    id: "3413",
    firstname: "Boluwatife",
    lastname: "Ogunleye",
    company: "TechNova Solutions",
    phone: "+1 (555) 123-4567",
    email: "james.smith@example.com",
    dateandtime: "25 Dec, 25 | 08:45AM",
    status: "Booked",
  },
  {
    id: "3414",
    firstname: "Boluwatife",
    lastname: "Ogunleye",
    company: "TechNova Solutions",
    phone: "+1 (555) 123-4567",
    email: "james.smith@example.com",
    dateandtime: "25 Dec, 25 | 08:45AM",
    status: "Booked",
  },
  {
    id: "3415",
    firstname: "Boluwatife",
    lastname: "Ogunleye",
    company: "TechNova Solutions",
    phone: "+1 (555) 123-4567",
    email: "james.smith@example.com",
    dateandtime: "25 Dec, 25 | 08:45AM",
    status: "Booked",
  },
  {
    id: "3416",
    firstname: "Boluwatife",
    lastname: "Ogunleye",
    company: "TechNova Solutions",
    phone: "+1 (555) 123-4567",
    email: "james.smith@example.com",
    dateandtime: "25 Dec, 25 | 08:45AM",
    status: "No Booking",
  },
  {
    id: "3417",
    firstname: "Boluwatife",
    lastname: "Ogunleye",
    company: "TechNova Solutions",
    phone: "+1 (555) 123-4567",
    email: "james.smith@example.com",
    dateandtime: "25 Dec, 25 | 08:45AM",
    status: "Booked",
  },
  {
    id: "3417",
    firstname: "Boluwatife",
    lastname: "Ogunleye",
    company: "TechNova Solutions",
    phone: "+1 (555) 123-4567",
    email: "james.smith@example.com",
    dateandtime: "25 Dec, 25 | 08:45AM",
    status: "Booked",
  },
  {
    id: "3418",
    firstname: "Boluwatife",
    lastname: "Ogunleye",
    company: "TechNova Solutions",
    phone: "+1 (555) 123-4567",
    email: "james.smith@example.com",
    dateandtime: "25 Dec, 25 | 08:45AM",
    status: "No Booking",
  },
  {
    id: "3419",
    firstname: "Boluwatife",
    lastname: "Ogunleye",
    company: "TechNova Solutions",
    phone: "+1 (555) 123-4567",
    email: "james.smith@example.com",
    dateandtime: "25 Dec, 25 | 08:45AM",
    status: "Booked",
  },
  {
    id: "3420",
    firstname: "Boluwatife",
    lastname: "Ogunleye",
    company: "TechNova Solutions",
    phone: "+1 (555) 123-4567",
    email: "james.smith@example.com",
    dateandtime: "25 Dec, 25 | 08:45AM",
    status: "No Booking",
  },
  {
    id: "3421",
    firstname: "Boluwatife",
    lastname: "Ogunleye",
    company: "TechNova Solutions",
    phone: "+1 (555) 123-4567",
    email: "james.smith@example.com",
    dateandtime: "25 Dec, 25 | 08:45AM",
    status: "No Booking",
  },
];

export default function Leads() {
  useEffect(() => {
    document.title = "Contacts";
  }, []);
  const { openModal } = useModal();
  const { openDrawer, closeDrawer } = useDrawer();
  const [page, setPage] = useState(0);
  const [filters, setFilters] = useState<any>({});
  const { error, data, isLoading, loading } = UseFetchData({
    dataType: "leads",
    page: page,
    filter: objectToUrlParams(filters),
  });

  return (
    <div className="w-full h-full">
      <div
        className={`flex flex-col md:flex-row gap-[16px] h-[34px] mb-[24px] ${"md:justify-between"}`}
      >
        <div className="flex flex-row justify-between">
          <SortByProject handleChange={setFilters} />
          {Object.keys(filters).filter((value) => value !== "campaign_id")
            .length > 0 &&
            filters.constructor === Object && (
              <ActionIcon
                className="p-0 m-0 !bg-transparent w-fit h-[35px] rounded-[4px] md:hidden"
                onClick={() => setFilters({})}
              >
                <Text className="font-[400] text-[#E63946] text-[13px] font-outfitRegular">
                  Clear all filters
                </Text>
              </ActionIcon>
            )}
        </div>

        <div className="flex md:flex-row md:gap-[12px] flex-wrap-reverse justify-between h-fit">
          <div className="w-[162px]">
            <StatusFilter
              handleChange={setFilters}
              page="leads"
              value={filters?.status}
            />
          </div>
          <Popover>
            <Popover.Trigger>
              <ActionIcon
                variant="text"
                className="h-[34px] w-[130px] rounded-[4px] border-[.5px] border-muted py-[10px] px-[16px] gap-[4px] bg-btn hover:text-background text-background"
              >
                <Add className={"text-primary-dark"} />
                <Text className="font-[400] font-gilroyMedium text-[12px] leading-[14.56px]">
                  Add contacts
                </Text>
              </ActionIcon>
            </Popover.Trigger>

            <Popover.Content className="p-0 dark:bg-[#191919] [&>svg]:dark:fill-[#191919]">
              <div className="bg-background w-[220px] rounded-[8px] p-[8px]">
                <Button
                  onClick={() =>
                    openModal({ view: <ImportFile page="leads" type="csv" /> })
                  }
                  variant="text"
                  className="text-primary-dark p-[16px] h-[44px] font-switzer text-[14px] font-[400] leading-[22px] bg-inherit hover:dark:!bg-[#303236] hover:bg-gray-100 w-full justify-start"
                >
                  Via csv
                </Button>
                <Button
                  onClick={() => openModal({ view: <SingleEntry /> })}
                  variant="text"
                  className="text-primary-dark p-[16px] h-[44px] font-switzer text-[14px] font-[400] leading-[22px] bg-inherit hover:dark:!bg-[#303236] hover:bg-gray-100 w-full justify-start"
                >
                  Single entry
                </Button>
              </div>
            </Popover.Content>
          </Popover>
          {Object.keys(filters).filter((value) => value !== "campaign_id")
            .length > 0 &&
            filters.constructor === Object && (
              <ActionIcon
                className="p-0 m-0 !bg-transparent w-fit h-[35px] rounded-[4px] md:block hidden"
                onClick={() => setFilters({})}
              >
                <Text className="font-[400] text-[#E63946] text-[13px] font-outfitRegular">
                  Clear all filters
                </Text>
              </ActionIcon>
            )}
        </div>
      </div>

      {loading && !error ? (
        <div className="h-full -mt-[68px]">
          <MyLoader />
        </div>
      ) : error ? (
        <Text className="font-switzer text-primary-dark text-[14px] text-center my-auto">
          {error?.message}
        </Text>
      ) : data?.data?.length > 0 ? (
        <div className="mt-[102px] md:mt-0">
          <DataTable
            data={data?.data}
            columns={basicColumns}
            setPage={setPage}
            isLoading={isLoading}
            meta={(row) => {
              openDrawer({
                view: (
                  <RightDrawer
                    row={row}
                    onClose={closeDrawer}
                    location={"leads"}
                  />
                ),
                placement: "right",
                containerClassName: "w-full md:!w-[435px]",
              });
            }}
            pageSize={data?.metadata?.pagination?.totalPages}
            error={error}
            defaultSort={{ id: "dateandtime", desc: true }}
          />
        </div>
      ) : (
        <div className="-mt-[34px] h-full">
          <BlankPage />
        </div>
      )}
    </div>
  );
}
